(() => {
  /*
    Clear localStorage item on logout, special for email subscription
  */

  // *= for query s string in css selector, to cover both /account/logout and /en/account/logout
  const logoutLinkElms = document.querySelectorAll('a[href*="/account/logout"]');
  logoutLinkElms.forEach(item => {
    item.addEventListener('click', function () {
      localStorage.removeItem('emailYN');
    })
  });
})();

(() => {
  /* 
    For Line Shopping Crawler
  */

  // Utility function to set a cookie
  const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    // Encode name and value for safety
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value || "") + expires + "; path=/";
  }

  // Update cart attributes with ecid for further use, such as order tracking in Line Shopping
  const updateCartAttr = async (attributes = {}) => {
    try {
      const body = JSON.stringify({
          attributes
      });
      await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    } catch (error) {
      console.error('Error updating cart ecid attribute:', error);
    }
  };

  const queryParams = new URLSearchParams(window.location.search);
  const ecid = queryParams.get('ecid');
  const attributes = {
    is_new_customer: window.is_new_customer
  };
  // Only run when ecid exists and has a non-empty value.
  if (ecid && ecid.trim()) {
    setCookie('ecid', ecid, 1);
    attributes.ecid = ecid.trim();
  }

  updateCartAttr(attributes);

})();